import React from 'react';

import styles from './Auction.module.css';

interface Props {
  hasEnded: boolean;
  winner: string;
  decoration: string;
  currentBid: string;
}

export const WinnerInfo = ({
  winner,
  hasEnded,
  decoration,
  currentBid,
}: Props) => {
  if (!hasEnded || !winner) {
    return null;
  }

  return (
    <div className={styles.winnerContainer}>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img src={decoration} />
      <div className={styles.winnerTitle}>sold for</div>
      <div className={styles.winnerBidContainer}>
        <div className={styles.winnerBid}>
          {/* TODO: Remove after AuctionPage.container.tsx currentBid is fixed */}
          5,500,000
          {/* {parseFloat(props.currentBid).toLocaleString('en-us', {
        maximumFractionDigits: 2,
        useGrouping: true,
      })} */}
        </div>
        <div className={styles.winnerBidUnit}>stars</div>
      </div>
      <div className={styles.winnerInfoContainer}>
        <div className={styles.winnerProfileName}>
          {/* TODO: Remove after AuctionPage.container.tsx winner is fixed */}
          0xBEBEEf2B9D52bf04685d1b61BA5b01aCFaE409e3
          {/* {winner} */}
        </div>
      </div>
    </div>
  );
};
